module.exports = __webpack_public_path__ + "static/media/goodreads.b4be5575.svg";